export interface IFeaturesResponse {
  feature_flags: ResponseFeature[];
}

export enum WebsiteABtestVariant {
  VariantA = 'variantA',
  VariantB = 'variantB',
}

export enum InstallCodeStepABtestVariant {
  Visible = 'visible',
  Hidden = 'hidden',
}

export interface ResponseFeature {
  name: string;
  value: boolean;
  variant?: { name: string; payload: { type: string; value: string } };
}

export enum FeatureNames {
  TestFeature = 'testFeature',
  ChatsListPagination = 'chatsListPagination',
  RichTextEditor = 'richTextEditor',
  DisturbingContentDetection = 'disturbingContentDetection',
  CustomerIntentEnabled = 'customerIntentEnabled',
  ReviewsReportEnabled = 'reviewsReportEnabled',
  InsightsReportsEnabled = 'recentInsightsEnabled',
  AISuggestions = 'aiSuggestions',
  ProductSwitcher = 'productSwitcher',
  PriorityChat = 'priorityChat',
  KnowledgeHubAddWebsiteOnboarding = 'knowledgeHubAddWebsiteOnboarding',
  AICannedInChips = 'aiCannedInChips',
  ReplySuggestionsFullMessageContext = 'replySuggestionsFullMessageContext',
  KnowledgeHubPdfCustomLimit = 'knowledgeHubPdfCustomLimit',
  OnboardingProvideWebsiteABtest = 'onboardingProvideWebsiteABtest',
  OnboardingInstallCodeStepABtest = 'onboardingInstallCodeStepABtest',
  GreetingsConfApiEnabled = 'greetingsConfapiEnabled',
  TextAppRedirectsEnabled = 'textAppRedirectsEnabled',
  MigrateCampaignConversionTo37 = 'migrateCampaignConversionTo37',
  LegacyProductsMigrationCampaign = 'legacyProductsMigrationCampaign',
}

type CustomFeatures = {
  [FeatureNames.KnowledgeHubPdfCustomLimit]: {
    enabled: boolean;
    limit: number;
  };
  [FeatureNames.OnboardingProvideWebsiteABtest]: {
    value: boolean;
    variant?: { name?: WebsiteABtestVariant };
  };
  [FeatureNames.OnboardingInstallCodeStepABtest]: {
    value: boolean;
    variant?: { name?: InstallCodeStepABtestVariant };
  };
};

export type Features = {
  [Key in FeatureNames]: Key extends keyof CustomFeatures ? CustomFeatures[Key] : boolean;
};
